<template>
  <div class="root-view">
    <div class="title-wrap">
      <img class="img-back" src="@/assets/target_college/ic_back_arrow.png" @click="navBack" />
      <span class="title">目标院校&专业</span>
    </div>

    <div class="content-wrap">
      <div class="input-wrap">
        <div class="input-item">
          <div class="item-label">目标院校</div>
          <el-select v-model="collegeName" placeholder="请选择你的目标大学" @change="selectCollege">
            <el-option
              v-for="item in collegeList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          <el-input placeholder="请输入你的目标大学"
                    v-model="form.college_name"
                    @input="submit"
                    v-show="collegeName == '其他'"/>
        </div>
        <div class="input-item">
          <div class="item-label">目标专业</div>
          <el-input placeholder="请输入你的目标专业"
                    v-model="form.professional"
                    @input="submit"/>
        </div>
      </div>

      <div class="public-version-wrap" v-if="user_version===1">
        <div class="public-version-title">对自己的目标院校&专业不够清晰？</div>
        <div class="public-version-desc">可扫码下载分多多APP或扫码登录分多多小程序，咨询专业的学业规划师，获取专属学业路径规划</div>
        <div class="tab-wrap">
          <div class="tab-item-wrap" v-for="(item, index) in tabList" :key="index" @click="selTab(index)">
            <div :class="[(curTab===index)?'tab-bar':'tab-bar-unsel']">{{ item }}</div>
            <img
                class="tab-indicator"
                src="@/assets/target_college/ic_introduce_indicator.png"
                v-show="curTab==index"/>
          </div>
        </div>
        <img
            class="public-version-img-num"
            :src="curTab===0?require('@/assets/target_college/ic_app_instroduce_num.png') : require('@/assets/target_college/ic_minprogram_instroduce_num.png')" />
        <img
            class="public-version-img-content"
            :src="curTab===0?require('@/assets/target_college/ic_app_instroduce_content.png') : require('@/assets/target_college/ic_minprogram_instroduce_content.png')" />

      </div>
      <div class="school-version-wrap" v-else-if="user_version===0">
        <div class="school-version-title">对自己的目标院校&专业不够清晰？</div>
        <div class="school-version-desc">打开微信扫一扫二维码添加客服好友，获取专属学业路径规划</div>
        <img class="img-wx-qrcode" src="@/assets/target_college/ic_wx_qr_code.png"/>
      </div>
      <div v-else></div>
    </div>

  </div>
</template>

<script>
import { getUserInfo, getCollegeList, submitCollegeTarget } from '@/api/subject.js'

export default{
  data(){
    return {
      user_version: 1,
      form: { college_name: '', professional: '' },
      collegeList:[],
      collegeName:'',
      tabList:['APP引导流程', '小程序引导流程'],
      curTab: 0
    }
  },
  methods: {
    navBack(){
      this.$router.go(-1)
    },
    selTab(index){
      this.curTab = index
    },
    selectCollege(el){
      if(this.collegeName == '其他') {
        this.form.college_name = ''
        return
      }
      this.form.college_name = this.collegeName
      this.submit()
    },
    async loadUserInfo () {
      const { data } = await getUserInfo()
      this.user_version = data.user_version
      this.form.college_name = data.college_name
      this.form.professional = data.professional
      this.collegeName = data.college_name
    },
    async loadCollegeList(){
       const {data} = await getCollegeList()
       this.collegeList = data.list
       this.collegeList.unshift({name:'其他', id: 0})
    },
    submit () {
      if(!this.form.college_name.length || this.form.college_name == '其他') return
      if(!this.form.professional.length) return
      submitCollegeTarget(this.form)
    },
  },
  created () {
    this.loadUserInfo()
    this.loadCollegeList()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input {
  display: flex;
  width: 675rem;
  height: 59rem;
  padding: 0 16rem;
  align-items: center;
  gap: 8rem;
  border-radius: 8rem;
  background: #f4f7ff;
}
::v-deep .el-input__inner {
  font-size: 24rem !important;
  border: none;
  background-color: transparent;
  background-image: none;

  font-size: inherit;
}

.root-view{
  width: 100vw;
  min-height: 100vh;
  // background: #DBEAFF;
  background: linear-gradient(359deg, #FFF 6.55%, #C8E4FC 52.03%, #DBEAFF 99.3%);
}

.title-wrap{
  width: 100%;
  height: 100rem;
  padding: 20rem;
  background: #DBEAFF;
  box-sizing: border-box;
  position: fixed;
  z-index: 10;
  top: 0rem;
  left: 0rem;
  right: 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .img-back{
    width: 40rem;
    height: 40rem;
    position: absolute;
    left: 40rem;
  }
  .title{
    color: #040C55;
    text-align: center;
    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem;
  }
}

.content-wrap{
  width: 100%;
  // background: linear-gradient(359deg, #FFF 6.55%, #C8E4FC 52.03%, #DBEAFF 99.3%);
  padding: 0rem 40rem;
  padding-top: 90rem;
  box-sizing: border-box;

  .input-wrap{
    display: flex;
    gap: 180rem;
    margin: 40rem 0rem 20rem 0rem;
    .input-item{
      display: flex;
      flex-direction: column;;
      gap: 16rem;
      .item-label{
        color: #040C55;
        font-size: 28rem;
        font-style: normal;
        font-weight: 600;
        line-height: 42rem;
      }
    }
  }

  .public-version-wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20rem;
    .public-version-title{
      color: #040C55;
      font-size: 40rem;
      font-style: normal;
      font-weight: 600;
      line-height: 54rem; /* 135% */
    }
    .public-version-desc{
      color: #040C55;
      font-size: 24rem;
      font-style: normal;
      font-weight: 400;
      line-height: 36rem; /* 150% */
      margin-top: 16rem;
    }

    .tab-wrap{
      padding: 30rem 0rem 0rem 0rem;
      display: flex;
      justify-content: center;
      gap: 16rem;
      .tab-item-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        .tab-bar,.tab-bar-unsel{
          display: flex;
          width: 560rem;
          height: 82rem;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 8rem;
          background: #1A87FF;
          color: #FFF;
          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
          line-height: 42rem; /* 150% */
        }
        .tab-bar-unsel{
          background: #93C7FF;
        }
        .tab-indicator{
          width: 64rem;
          height: 41rem;
          position: relative;
          top: -20rem;
        }
      }
    }

    .public-version-img-num{
      width: 100%;
      height: auto;
    }
    .public-version-img-content{
      width: 100%;
      height: auto;
    }
  }

  .school-version-wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40rem 32rem;
    .school-version-title{
      color: #040C55;
      text-align: center;
      font-size: 40rem;
      font-style: normal;
      font-weight: 600;
      line-height: 54rem; /* 135% */
    }
    .school-version-desc{
      color: #040C55;
      text-align: center;
      font-size: 24rem;
      font-style: normal;
      font-weight: 400;
      line-height: 36rem; /* 150% */
      margin-top: 16rem;
    }
    .img-wx-qrcode{
      width: 300rem;
      height: 300rem;
      margin-top: 40rem;
    }
  }

}


</style>